const types = [
  {
    name: 'Activos',
    value: 'active'
  },
  {
    name: 'Inactivos',
    value: 'inactive'
  },
  {
    name: 'Pendiente',
    value: 'pending'
  },
  {
    name: 'Pendiente de pago',
    value: 'outstanding'
  },
  {
    name: 'Pendiente de validación del RGCC',
    value: 'pending-rgcc'
  },
  {
    name: 'Bloqueados',
    value: 'blocked'
  }
]

export { types }
